import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useMounted, useNow } from '@vueuse/core';

import type { ObjectType } from '@/@types/graphql-types';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { LinearTitleOffer } from '@/interfaces/buybox';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import GridOffer from '@/features/buybox/components/grid/GridOffer.vue';
import { formatDateTime } from '@/helpers/date-helper';
import { useLinearBroadcastTime } from '@/components/experiments/LinearTVExp';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearOffer',
  props: {
    title: null,
    offer: null,
    objectType: null
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	offer: LinearTitleOffer;
	objectType: ObjectType;
};





const { language, country } = storeToRefs(useLanguageStore());
const { broadcastTimeZone } = useLinearBroadcastTime();

// Live status
const isMounted = useMounted();
const now = useNow({ interval: 60000 });
const liveStatus = computed(() => {
	if (!isMounted.value) return false;
	return new Date(props.offer.availableFromTime) <= now.value && now.value < new Date(props.offer.availableToTime);
});

const dateOptions = {
	day: 'numeric',
	month: 'short',
} as const;

const timeOptions = {
	hour: 'numeric',
	minute: 'numeric',
} as const;

const formattedDate = computed(() => {
	const options = { ...dateOptions, timeZone: broadcastTimeZone.value };
	return formatDateTime(new Date(props.offer.availableFromTime), language.value, country.value, options);
});

const formattedTime = computed(() => {
	const options: Intl.DateTimeFormatOptions = {
		...timeOptions,
		timeZoneName: 'short',
		timeZone: broadcastTimeZone.value,
	};
	return formatDateTime(new Date(props.offer.availableFromTime), language.value, country.value, options);
});

return { __sfc: true,props, language, country, broadcastTimeZone, isMounted, now, liveStatus, dateOptions, timeOptions, formattedDate, formattedTime, GridOffer }
}

})